export const clinicOpeningTime = 9;
export const clinicCloseTime = 18;